module.exports = __webpack_public_path__ + "static/homeVideoWebm-8104f1f81d5545d604eab59e11110f79.webm";